var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "modals-container" } },
    _vm._l(_vm.modals, function(modal) {
      return _c(
        "modal",
        _vm._g(
          _vm._b(
            {
              key: modal.id,
              on: {
                closed: function($event) {
                  return _vm.remove(modal.id)
                }
              }
            },
            "modal",
            modal.modalAttrs,
            false
          ),
          modal.modalListeners
        ),
        [
          _c(
            modal.component,
            _vm._g(
              _vm._b(
                {
                  tag: "component",
                  on: {
                    close: function($event) {
                      return _vm.$modal.hide(modal.modalAttrs.name)
                    }
                  }
                },
                "component",
                modal.componentAttrs,
                false
              ),
              _vm.$listeners
            )
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-296d0a73", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-296d0a73","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/modal/ModalsContainer.vue
// module id = 6Fgh
// module chunks = 0